// Testing
export const environment = {
    production: true,
    PRIVATE_TESTING: false,
    IS_STAGING: true,

    API_URL: 'https://testing.saideline.com/api/v1',

    /** Google Analytics 4 measurement ID (conversions are imported into Google Ads from this property). */
    GA_MEASUREMENT_ID: 'G-4RQ558J8LX',

    /**
     * Google Consent Mode v2. "advanced": the Google tag runs for every visitor with consent denied
     * by default, so Google can model conversions of visitors who reject cookies (no cookies are
     * stored for them). "basic": the tag only loads after the visitor accepts.
     */
    GOOGLE_CONSENT_MODE: 'advanced' as 'advanced' | 'basic',

    localization: {
        defaultLanguage: 'en',
        supportedLanguages: ['en', 'de'],
    },
};
